export type TaskPriority = 'low' | 'medium' | 'high';

export type TaskStatus = 'open' | 'completed' | 'overdue';

export type TaskSourceType = 'message';

export interface TaskSourceRef {
  message_id: string;
}

export const PRIORITY_LABEL: Record<TaskPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

/** Request body for `POST /v2/tasks`. */
export interface CreateTaskPayload {
  title: string;
  description: string | null;
  priority: TaskPriority | null;
  assignee_id: string;
  /** RFC3339 UTC date-time, must be in the future, or null. */
  due_at: string | null;
  reminder_enabled: boolean;
  source_type: TaskSourceType;
  source_ref: TaskSourceRef;
}

/** A task as returned by task-svc. */
export interface Task {
  id: string;
  title: string;
  description: string | null;
  priority: TaskPriority | null;
  assignee_id: string;
  due_at: string | null;
  reminder_enabled: boolean;
  status: TaskStatus;
  source_type: TaskSourceType;
  source_ref: TaskSourceRef;
  creator_id: string;
  created_at: string;
  updated_at: string;
  completed_at?: string | null;
}

type AtLeastOne<T> = { [K in keyof T]: Pick<T, K> }[keyof T] & Partial<T>;

interface UpdateTaskFields {
  title?: string;
  description?: string | null;
  priority?: TaskPriority | null;
  /** RFC3339 UTC date-time, or null. */
  due_at?: string | null;
  reminder_enabled?: boolean;
}

/** Request body for `PATCH /v2/task-management/tasks/:task_id`. At least one field required. */
export type UpdateTaskPayload = AtLeastOne<UpdateTaskFields>;

/** task-svc error envelope: `{ error: { code, message, field? } }`. */
export interface TaskSvcErrorBody {
  code: string;
  message: string;
  field?: string;
}
